export class EncounterType {
    id = null;
    name = null;
    code = null;
    description = null;
}